module.exports = __webpack_public_path__ + "static/media/12.e8b48378.jpg";